import { compose } from '@/utils/reducerUtils';

import { applyAutoLayoutToState, applySectionBoundsToState } from '../state';
import { AutoPositionAction, EntityDiagramActionFn } from '../types';

export const autoPositionAction: EntityDiagramActionFn<AutoPositionAction> = (
  state,
  _action,
  queueEffect
) => {
  const { presentationMode } = state;

  queueEffect({ type: 'fitViewEffect', presentationMode });

  // Apply auto layout to reposition nodes, ignoring existing positions
  const { state: newState } = applyAutoLayoutToState(state);

  return compose(applySectionBoundsToState)(newState);
};
